import React from 'react'
import { calculateDpi as calculateArtworkDpi, getDpiQuality } from './artworkQuality'

export { calculateDpi } from './artworkQuality'

export default function DpiBadge({ widthPx, heightPx, printWidthIn, printHeightIn }) {
  const dpi = calculateArtworkDpi(widthPx, heightPx, printWidthIn, printHeightIn)

  if (dpi === null) return null

  if (getDpiQuality(dpi) === 'good') {
    return <span className="dpi-badge dpi-badge--green">Resolution ready ({Math.round(dpi)} DPI)</span>
  } else if (getDpiQuality(dpi) === 'caution') {
    return <span className="dpi-badge dpi-badge--yellow">May appear soft ({Math.round(dpi)} DPI)</span>
  } else {
    return <span className="dpi-badge dpi-badge--red">Low DPI detected ({Math.round(dpi)} DPI)</span>
  }
}
